<template>
  <v-col cols="auto">
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="1000" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition> 
          <v-btn 
            color="primary"
            v-bind="attrs"
            v-on="on"            
            small
            :disabled="!logicaIntervencao.edicao"
          >Editar</v-btn>
        </v-fab-transition>
      </template>
      <template>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-toolbar color="primary" tile elevation="0" dark>{{ titulo }}</v-toolbar>

            <v-list-item v-if="realizacao">
              <v-list-item-content>
                <v-list-item-subtitle>{{ realizacao.posicaoFormatada }} Realização</v-list-item-subtitle>
                <v-list-item-title class="text-wrap">{{ realizacao.descricao }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="realizacao"></v-divider>
            <v-list-item v-if="produto">
              <v-list-item-content>
                <v-list-item-subtitle>{{ produto.posicaoFormatada }} Produto</v-list-item-subtitle>
                <v-list-item-title class="text-wrap">{{ produto.descricao }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="produto"></v-divider>

            <v-card-text>
              <v-row>
                <v-col cols="12" lg="3" class="mb-n6">
                  <v-select class="text-center"
                    :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]"
                    label="Posição"
                    :rules="[v => !!v || 'Posição é obrigatória.']"
                    filled
                    v-model="formulario.posicao"
                  ></v-select>
                </v-col>
                <v-col cols="12" class="mb-n6">
                  <v-textarea
                    v-model="formulario.descricao"
                      label="Título"
                      filled
                      rows="2"
                      auto-grow
                      :rules="[v => !!v || 'Título é obrigatório.']"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="formulario.condicoesPreviasExternas"
                    filled
                    label="Quais as condições prévias e externas?"
                    rows="3"
                    auto-grow
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end">

              <v-btn color="secondary" @click.prevent="fecharELimpar">Cancelar</v-btn>
              <v-btn :loading="isFetching" color="primary" type="submit"> Salvar alterações </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </v-dialog>
  </v-col>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  props: {
    titulo: {
      require: true,
    },
    nivel: {
      require: true,
    },
    realizacao: {
      require: false,
    },
    produto: {
      require: false,
    },
    logicaIntervencao: {
      required: false,
    },
  },
  computed: {
    ...mapState('logicaIntervencao', {
      isFetching: state => state.isFetching,
    }),
  },
  data() {
    return {
      valid: true,
      dialog: false,
      formulario: {}
    };
  },
  created() {
    this.formulario = {...this.logicaIntervencao}
  },
  methods: {
    ...mapActions('logicaIntervencao', ['editarLogicaIntervencao']),

    save() {
      if(this.$refs.form.validate()) {
        this.update().then((logicaIntervencao) => {
          this.$refs.form.resetValidation()
          this.formulario = {};
          this.$emit("save", { logicaIntervencao });
          this.fecharELimpar()
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
      }
    },
    update() {
      return this.editarLogicaIntervencao(this.formulario);
    },
    fecharELimpar() {
      this.formulario = {...this.logicaIntervencao}
      this.dialog = false
    },
  
  },  
};
</script>